import { pickT } from "@repo/shared";
import type { PortfolioOrderStatus } from "@repo/shared/types";
import { Badge } from "@/components/ui/badge";
import { T } from "./order-status-badge.i18n";

const VARIANTS: Record<
  PortfolioOrderStatus,
  "secondary" | "info" | "success" | "warning" | "destructive"
> = {
  pending: "secondary",
  submitted: "info",
  executed: "success",
  partially_executed: "warning",
  failed: "destructive",
  cancelled: "secondary",
  modified: "warning",
};

/** Every status, in filter order. */
export const ORDER_STATUSES: PortfolioOrderStatus[] = [
  "pending",
  "submitted",
  "executed",
  "partially_executed",
  "failed",
  "cancelled",
  "modified",
];

export function orderStatusLabel(status: PortfolioOrderStatus, language: string): string {
  return pickT(T, language).status[status] ?? status;
}

type OrderStatusBadgeProps = {
  status: PortfolioOrderStatus;
  /** UI language; unknown codes fall back to en_GB. */
  language: string;
  title?: string;
};

export function OrderStatusBadge({ status, language, title }: OrderStatusBadgeProps) {
  return (
    <Badge variant={VARIANTS[status] ?? "secondary"} title={title}>
      {orderStatusLabel(status, language)}
    </Badge>
  );
}
